<template>

  <b-card-actions ref="list"
title="" action-refresh @refresh="refresh">

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <export-excel
            :data="rows"
            :columns="excel_columns"
            :file-name="'document_sections'"
            :file-type="'xlsx'"
            :sheet-name="'sheetname'"
          >
            <feather-icon icon="DownloadIcon" />
          </export-excel>

          <b-button
            variant="primary"
            class="button-inline-spacing-2"
            @click="add_company()"
            v-if="!canAddCompany"
>
            <span class="text-nowrap">{{ $t("Add Company") }}</span>
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="position-relative has-icon-left">
            <b-form-input
              v-model="searchTerm"
              :placeholder="$t('message.SearchPlaceholder')"
              type="text"
              class="d-inline-block"
              @input="debouncedSearch"
              :disabled="isLoading"
            />
            <div
v-if="isLoading"
class="spinner-border spinner-border-sm text-primary position-absolute"
                 style="right: 1rem; top: 0.75rem;"
                 role="status"
>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </b-col>
      </b-row>

    </div>

    <!-- alert -->
    <!--b-alert
      variant="primary"
      show
    >
      <div class="alert-body">
      </div>
    </b-alert-->

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end"/>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: false, // Disable built-in search, we handle it ourselves
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
        dropdownAllowAll: false
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'name', type: 'asc'}
      }"
      :is-loading.sync="isLoading"
      style-class="vgt-table striped"
      :line-numbers="false"
    >

      <!-- Slot: Table Column -->
      <template
        slot="table-column"
        slot-scope="props"
      >

        <span>
          {{ $t(props.column.label) }}
        </span>
      </template>

      <!-- Slot: Table Row -->
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Logo -->
        <span
          v-if="props.column.field === 'logo'"
          class="text-nowrap v-align-middle"
        >
          <span v-if="props.row.logo">
            <img
              :src="props.row.logo"
              class="mr-8 rounded h-24 w-24 profile-pic-list"
              loading="lazy"
              ref="companyLogo"
              @error="handleImageError($event)"
            >
          </span>
          <span v-else
class="avatar-placeholder rounded d-inline-flex align-items-center justify-content-center mr-8 h-24 w-24 bg-light-primary">
            {{ getInitials(props.row.name) }}
          </span>
        </span>

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'name'"
          class="text-nowrap v-align-middle"
        >
          <span>{{ props.row.name }}</span>
        </span>

        <!-- Column: Vat Number -->
        <span
          v-else-if="props.column.field === 'vat_number'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.vat_number }}</span>

        </span>

        <!-- Column: employees_count -->
        <span
          v-else-if="props.column.field === 'employees_count'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.employees_count }}</span>

        </span>

        <!-- Column: users_count -->
        <span
          v-else-if="props.column.field === 'users_count'"
          class="text-nowrap align-middle"
        >
          <span>{{ props.row.users_count }}</span>

        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'"
class="button-inline-spacing">

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon"
            @click="edit(props.row.id)"
>
            <feather-icon icon="Edit2Icon" />
          </b-button>

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon"
            @click="deleteCompany(props.row)"
            :disabled="editDisabled"
>
            <feather-icon icon="TrashIcon" />
          </b-button>

        </span>

        <span v-else
class="text-nowrap align-middle"/>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >

        <div class="d-flex justify-content-between flex-wrap">

          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ $t('message.pagelength') }}
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10','15']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{ $t('message.pageText2') }} </span>
          </div>
          <div>

            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>

            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <template #code/>
  </b-card-actions>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BCardActions } from '@core/components/b-card-actions';
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BAlert, BDropdown, BDropdownItem, BRow, BCol,
BButton} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import {codeI18n} from './code'
import useJwt from '@/auth/jwt/useJwt'
import UserService from "@/basic/userService";
import EmployeeService from "@/basic/employeeService";
import Ripple from 'vue-ripple-directive'
import { debounce } from 'lodash'

import ExportExcel from '@/views/components/excel-export/ExportExcel';

import Vue from 'vue';
import i18n from '@/libs/i18n';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import ability from '@/libs/acl/ability';

Vue.use(ExportExcel)

export default {
  components: {
    BCardCode,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 15,
      codeI18n,
      dir: false,
      editDisabled: !ability.can('manage', "Basic Admin"),
      userData: JSON.parse(localStorage.getItem('userData')),
      isLoading: false,
      allCompanies: [], // Store all companies
      filteredRows: [], // Store filtered rows

      columns: [
        {
          label: 'Logo',
          field: 'logo',
        },
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Vat Number',
          field: 'vat_number',
        },

        {
          label: 'Users',
          field: 'users_count',
        },

        {
          label: 'Employees',
          field: 'employees_count',
        },

        {
          label: 'action',
          field: 'action',
        },

      ],
      excel_columns: [
        {
          label: i18n.t('Name'),
          field: 'name',
        },
        {
          label: 'Vat Number',
          field: 'vat_number',
        },
        {
          label: 'Address',
          field: 'address',
        },
        {
          label: i18n.t('Employees'),
          field: 'employees_count',
        },

      ],
      rows: [],
      debouncedSearch: null,
      searchTerm: '',

    }
  },
  computed: {
    canAddCompany(){
      console.log('editDisabled', this.editDisabled)
      console.log('userData', this.userData)
      let isAdmin = this.userData && this.userData.role === 'admin'
      return (this.editDisabled || !isAdmin)
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    // Create debounced search function
    this.debouncedSearch = debounce(this.performSearch, 300);
  },
  methods: {
    refresh() {
      console.log('refresh')
      this.$refs.list.showLoading = true
      this.isLoading = true

      const userService = new UserService(useJwt)

      userService.companies({}).then(response => {
        this.allCompanies = response.data.data
        // Apply any active filters
        this.performSearch()
        console.log('rows loaded:', this.allCompanies.length)
        this.$refs.list.showLoading = false
        this.isLoading = false
      }).catch(error => {
        console.error('Error loading companies:', error)
        this.$refs.list.showLoading = false
        this.isLoading = false
      })
    },

    // New optimized search method
    performSearch() {
      this.isLoading = true

      // If search term is empty, show all rows
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        this.rows = this.allCompanies
        this.isLoading = false
        return
      }

      const searchTermLower = this.searchTerm.toLowerCase()

      // Filter the rows directly using a more efficient approach
      this.rows = this.allCompanies.filter(row => 
        // Only search in the most important fields
         (
          (row.name && row.name.toLowerCase().includes(searchTermLower)) ||
          (row.vat_number && row.vat_number.toLowerCase().includes(searchTermLower))
        )
      )

      this.isLoading = false
    },

    // Get initials for avatar placeholder
    getInitials(name) {
      if (!name) return '??'
      return name
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .substring(0, 2)
        .toUpperCase()
    },

    // Handle image loading errors
    handleImageError(event) {
      event.target.style.display = 'none'
      // Find the parent element and add a placeholder
      const parent = event.target.parentNode
      const company = this.allCompanies.find(c => c.logo === event.target.src)
      const name = company ? company.name : ''

      // Create placeholder with initials
      const placeholder = document.createElement('span')
      placeholder.className = 'avatar-placeholder rounded d-inline-flex align-items-center justify-content-center mr-8 h-24 w-24 bg-light-primary'
      placeholder.textContent = this.getInitials(name)

      parent.appendChild(placeholder)
    },

    add_company() {
      this.$router.push({ name: 'company', params: { id: 'new' } })
    },

    edit(id) {
      this.$router.push({ name: 'company', params: { id: id } })
    },

    deleteCompany(row) {
      console.log('delete')
      let confirmed = false
      let message = `${i18n.t('You are deleting the company')  }: "${  row.name  }". ${  i18n.t("Are you sure?")}`;

      this.$bvModal
        .msgBoxConfirm(message, {
          title: i18n.t('Confirmation Required'),
          size: 'sm',
          okVariant: 'primary',
          okTitle: i18n.t('Proceed'),
          cancelTitle: i18n.t('Cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          confirmed = value

          if (confirmed) {
            this.isLoading = true
            const userService = new UserService(useJwt)
            userService.delete_company(row.id).then(response => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: i18n.t('Company deleted'),
                  icon: 'AlertIcon',
                  variant: 'success',
                  text: i18n.t('Company deleted with success'),
                },
              })
              this.refresh()
              }).catch(error => {
              console.error('Error deleting company:', error)
              this.isLoading = false
            })
          }
        })
    },

    list_documents(id) {
      this.$router.push({ name: 'documents', params: { document_section_id: id } })
    },
  },
  mounted() {
    const employeeService = new EmployeeService(useJwt)
    this.$refs.list.showLoading = true

    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === 'selected_company') {
        console.log(`Updating selected_company to ${state.userCompany.id}`)
        this.refresh()
      }
    })


    this.refresh()
    // this.$http.get('/good-table/basic')
    // .then(res => { this.rows = res.data })
  },
  beforeDestroy() {
    this.unsubscribe()
  }
}
</script>

<style scoped>
.avatar-placeholder {
  color: #7367f0;
  font-weight: bold;
  font-size: 0.8rem;
  min-width: 24px;
}

.position-relative {
  position: relative;
}

.has-icon-left .form-control {
  padding-right: 2.5rem;
}

.position-absolute {
  position: absolute;
}
</style>
